/**
 * Group page (#/group) sharing context line HTML (FE-G1).
 */

/**
 * @param {object} ctx
 * @param {boolean} ctx.isSharedGroup
 * @param {boolean} ctx.canOpenGroupShare
 * @param {string} ctx.sharedByLine — already escaped or safe mono content
 * @param {(s: string) => string} ctx.escapeHtml
 * @returns {string}
 */
export function buildGroupSharingContextLineHtml(ctx) {
  const { isSharedGroup, canOpenGroupShare, sharedByLine, escapeHtml } = ctx;
  if (isSharedGroup) {
    return (
      `<p id="groupSharingContextLine" class="muted" style="margin-top:8px;font-size:12px">` +
      `<strong>Shared group</strong> — account owner: <span>${sharedByLine || "—"}</span>. ` +
      `Alarms use only devices you may operate.</p>`
    );
  }
  if (canOpenGroupShare) {
    return (
      `<p id="groupSharingContextLine" class="muted" style="margin-top:8px;font-size:12px">` +
      `<strong>Owner view</strong> — use <strong>Share group</strong> to grant access.</p>`
    );
  }
  return (
    `<p id="groupSharingContextLine" class="muted" style="margin-top:8px;font-size:12px">` +
    `${escapeHtml("Device list matches your account scope.")}</p>`
  );
}
